import { isTesting } from 'js/src/libs/custom-utils';

type CenterSlideInfo = {
    center_slide_id: string;
    center_slide_index: number;
    center_sub_scene_index: number;
    center_slide_group_id: string;
};

class FocusAndScroll {
    /**
     * Control scrolling for the creator
     */
    static scrollToSlide(slideId: string, subsceneIndex = 0, retryIfNotFound = true): void {
        const slide = document.querySelector(
            `.slide-row[data-slideid="${slideId}"][data-subsceneindex="${subsceneIndex}"]`,
        );
        if (!slide) {
            // Some operations add new scene to luminary and trigger scroll to the new scene.
            // React has not yet added the new scene to the DOM.
            // Trigger scroll after DOM update.
            if (retryIfNotFound) {
                setTimeout(() => {
                    FocusAndScroll.scrollToSlide(slideId, subsceneIndex, false);
                }, 100);
            }
            return;
        }
        slide.scrollIntoView({
            behavior: isTesting() ? 'instant' : 'smooth',
            block: 'center',
            inline: 'nearest',
        });
    }

    /**
     * Calculates the current centermost scene
     */
    static calculateCentermostSceneInfo(): CenterSlideInfo | undefined {
        const scrollParent = document.getElementById('long-form-creator-container');
        if (!scrollParent) {
            return;
        }
        const scrollParentRect = scrollParent.getBoundingClientRect();
        const scrollParentMiddle = scrollParentRect.top + scrollParentRect.height / 2;

        let nearestSlide: HTMLDivElement | null = null;
        let nearestDistance = Infinity;
        const slides = document.querySelectorAll<HTMLDivElement>(
            '.slide-row.actually-contains-slide',
        );
        for (let i = 0; i < slides.length; i++) {
            const slide = slides[i];
            const slideRect = slide.getBoundingClientRect();
            const slideMiddle = slideRect.top + slideRect.height / 2;
            const distance = Math.abs(scrollParentMiddle - slideMiddle);
            if (distance < nearestDistance) {
                nearestDistance = distance;
                nearestSlide = slide;
            }
        }

        if (!nearestSlide) {
            return undefined;
        }
        const center_slide_group_id = nearestSlide.dataset.scenegroupid;
        const center_slide_id = nearestSlide.dataset.slideid;
        const center_slide_index = nearestSlide.dataset.sceneindex;
        const center_sub_scene_index = nearestSlide.dataset.subsceneindex;
        if (
            center_slide_group_id &&
            center_slide_id &&
            center_slide_index &&
            center_sub_scene_index
        ) {
            return {
                center_slide_group_id,
                center_slide_id,
                center_slide_index: parseInt(center_slide_index),
                center_sub_scene_index: parseInt(center_sub_scene_index),
            };
        }
        return undefined;
    }

    static getScrollParent(element: HTMLElement): HTMLElement | undefined {
        let parent = element.parentElement;

        while (parent) {
            const style = getComputedStyle(parent);
            const overflowY = style.overflowY;
            const isScrollable = overflowY === 'auto' || overflowY === 'scroll';

            if (isScrollable && parent.scrollHeight > parent.clientHeight) {
                return parent;
            }

            parent = parent.parentElement;
        }
    }
}

export default FocusAndScroll;
